export default "__VITE_ASSET__th6ZNMSW__"